"use strict";

class ArchivePermit {
    constructor(skipInit = false) {
        if (!skipInit) {
            this._init()
        }
    } 

    get permitFilters() {
        return document.querySelectorAll('.archive-permit__filter')
    }
    get anyFiltersOpen() {
        return [...this.permitFilters].some(filter => filter.open)
    }

    waitForFiltersClosed() {
        return new Promise(resolve => {
            const filtersCheckInterval = setInterval(() => {
                if (!this.anyFiltersOpen) {
                    clearInterval(filtersCheckInterval)
                    resolve()
                }
            }, 100)
        })
    }
    closeAllFilters() {
        const permitFilters = this.permitFilters

        permitFilters.forEach(filter => {
            filter.open = false
        })
    }

    _init() {
        const permitFilters = this.permitFilters

        permitFilters.forEach(filter => {
            filter.addEventListener('toggle', toggleOpenFilterOnly)
        })

        function toggleOpenFilterOnly(e) {
            if (this.open) {
                permitFilters.forEach(filter => {
                    if (filter != this && filter.open) {
                        filter.open = false
                    }
                })
            }
        }

        document.addEventListener('click', ({ target }) => {
            const clickedOnFilter = [...permitFilters].filter(filter => filter === target || filter.contains(target)).length

            if (!clickedOnFilter) {
                this.closeAllFilters()
            }
        })
        document.addEventListener('keyup', ({ code }) => {
            if (code === 'Escape') {
                this.closeAllFilters()
            }
        })
    }
}

module.exports = ArchivePermit;
